import { apiAction } from 'apa/actions'
import * as types from 'catalog/actions/types'
import {fetchCheckpointList} from 'catalog/actions/checkpoints'

export const remove = (category) => (dispatch, getState) => {
  const doSubcategory = !!category.parent
  const listName = doSubcategory ? 'subcategoryList' : 'categoryList'
  const state = getState()
  const currentList = state.categories[listName].filter(elem => elem.id !== category.id)
  dispatch(apiAction({
    url: `/api/categories/${category.id}/`,
    method: 'DELETE',
    onSuccess: () => ({
      type: doSubcategory ? types.DELETE_SUBCATEGORY : types.DELETE_CATEGORY,
      payload: {
        [listName]: currentList
      }
    })
  }))
}

export const fetchCategoryList = () => dispatch => {
  dispatch({
    type: types.FETCH_CATEGORY_LIST
  })
  dispatch(apiAction({
    url: '/api/categories/',
    onSuccess: categoryList => ({
      type: types.FETCH_CATEGORY_LIST_SUCCESS,
      payload: {
        categoryList: categoryList
      }
    })
  }))
}

export const fetchSubcategoryList = () => (dispatch, getState) => {
  const activeCategory = getState().categories.activeCategory
  dispatch(apiAction({
    url: `/api/categories/${activeCategory.id}/children/`,
    onSuccess: subcategoryList => ({
      type: types.FETCH_SUBCATEGORIES,
      payload: {
        subcategoryList: subcategoryList,
        checkpointList: [],
      }
    })
  }))
}



export const chooseCategory = (category) => dispatch => {
  if (!category.parent) {
    dispatch({
      type: types.CHOOSE_CATEGORY,
      payload: {
        activeCategory: category,
      }
    })
    dispatch(fetchSubcategoryList())
  } else {
    dispatch({
      type: types.CHOOSE_SUBCATEGORY,
      payload: {
        activeSubcategory: category,
      }
    })
    dispatch(fetchCheckpointList())
  }
}

export const unchooseCategory = (subcategory = false) => dispatch => dispatch(
  {
    type: subcategory ? 'UNCHOOSE_SUBCATEGORY' : 'UNCHOOSE_CATEGORY'
  }
)


export const searchCategory = (text) => dispatch => dispatch(
  apiAction({
    url: `/api/categories/?&search=${text}`,
    onSuccess: categoryList => ({
      type: types.SEARCH_CATEGORY,
      payload: {
        categoryList: categoryList
      }
    })
  })
)


export const updateCategory = (category) => (dispatch, getState) => {
  const state = getState()
  const categoryList = state.categories.categoryList
  dispatch(apiAction({
    url: `/api/categories/${category.id}/`,
    method: 'PATCH',
    data: category,
    onSuccess: category => ({
      type: types.UPDATE_CATEGORY,
      payload: {
        activeCategory: category,
        categoryList: categoryList.map(el => el.id === category.id ? category : el)
      }
    })
  }))
}

export const updateSubcategory = (subcategory) => (dispatch, getState) => {
  const state = getState()
  const subcategoryList = state.categories.subcategoryList
  dispatch(apiAction({
    url: `/api/categories/${subcategory.id}/`,
    method: 'PATCH',
    data: subcategory,
    onSuccess: subcategory => ({
      type: types.UPDATE_SUBCATEGORY,
      payload: {
        activeSubcategory: subcategory,
        subcategoryList: subcategoryList.map(el => el.id === subcategory.id ? subcategory : el)
      }
    })
  }))
}

export const addCategory = (category) => (dispatch, getState) => {
  dispatch(apiAction({
    url: '/api/categories/',
    method: 'POST',
    data: category,
    onSuccess: category => {
      const state = getState()
      if (category.parent) {
        const subcategoryList = [category, ...state.categories.subcategoryList]
        return {
          type: types.ADD_SUBCATEGORY,
          payload: {
            subcategoryList: subcategoryList,
            activeSubcategory: category
          }
        }
      } else {
        const categoryList = [category, ...state.categories.categoryList, category]
        return {
          type: types.ADD_CATEGORY,
          payload: {
            categoryList: categoryList,
            activeCategory: category
          }
        }
      }
    }
  }))
}

const reorderList = (list, start, end) => {
  const result = Array.from(list)
  const [removed] = result.splice(start, 1)
  result.splice(end, 0, removed)
  return result
}

export const reorderCategoryList = (result) => (dispatch, getState) => {
  const categories = getState().categories
  const doSubcategory = result.source.droppableId === 'subcategory'
  const categoryList = doSubcategory ? categories.subcategoryList : categories.categoryList
  const listName = doSubcategory ? 'subcategoryList' : 'categoryList'
  const startIndex = result.source.index
  const endIndex = result.destination.index
  if (startIndex === endIndex) { return }
  dispatch({
    type: doSubcategory ? types.REORDER_SUBCATEGORIES : types.REORDER_CATEGORIES,
    payload: {
      [listName]: reorderList(categoryList, startIndex, endIndex)
    }
  })
  dispatch(apiAction({
    url: '/api/categories/ordering/',
    method: 'POST',
    data: {
      movedId: categoryList[startIndex].id,
      targetId: categoryList[endIndex].id,
      doSubcategory: doSubcategory
    }
  }))
}
